import { render, staticRenderFns } from "./productImageList.vue?vue&type=template&id=65934ded&"
import script from "./productImageList.vue?vue&type=script&lang=js&"
export * from "./productImageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65934ded')) {
      api.createRecord('65934ded', component.options)
    } else {
      api.reload('65934ded', component.options)
    }
    module.hot.accept("./productImageList.vue?vue&type=template&id=65934ded&", function () {
      api.rerender('65934ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/productImageList.vue"
export default component.exports